import { useCallback } from "react";
import { VocabularyListenCounts } from "../utils/vocabularyListenCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useVocabularyListenCounts() {
    const { data: counts, update, syncStatus } = useDeviceProgress<VocabularyListenCounts>("vocabularyListenCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus };
}
